import React from 'react'

import Header from '../../../components/Header'

export default () => (
  <Header title="Mais opções" />
)